import { http, requestBlob } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { DeclarationsApi } from './declarations';

// Paths mirror subsystems/identity/facade/adapters/admin-api/src/admin/declarations.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const declarationsHttp: DeclarationsApi = {
  listDeclarationTemplates: (opts) => http.get('api', '/declaration-templates', rd(opts)),
  declarationTemplatePreview: (code, opts) => requestBlob('api', `/declaration-templates/${seg(code)}/preview`, undefined, opts?.signal),
  listSubjectDeclarations: (subjectId, opts) => http.get('api', `/subjects/${seg(subjectId)}/declarations`, rd(opts)),
  listDomainDeclarations: (key, opts) => http.get('api', `/domains/${seg(key)}/declarations`, rd(opts)),
  getDeclaration: (id, opts) => http.get('api', `/declarations/${seg(id)}`, rd(opts)),
  generateDeclaration: (subjectId, body, opts) => http.post('api', `/subjects/${seg(subjectId)}/declarations`, body, wr(opts)),
  uploadDeclaration: (id, body, opts) => http.post('api', `/declarations/${seg(id)}/uploads`, body, wr(opts)),
  declarationPdf: (id, reason, opts) => requestBlob('api', `/declarations/${seg(id)}/pdf`, { reason }, opts?.signal),
  declarationUploadFile: (submissionId, reason, opts) => requestBlob('api', `/declaration-uploads/${seg(submissionId)}/file`, { reason }, opts?.signal),
  getTrustStore: (opts) => http.get('api', '/trust-store', rd(opts)),
  getDeclarationCheckSettings: (opts) => http.get('api', '/declaration-check-settings', rd(opts)),
  updateDeclarationCheckSettings: (body, opts) => http.put('api', '/declaration-check-settings', body, wr(opts)),
  // subsystems/identity/facade/adapters/admin-api/src/admin/vn_zones.rs
  listVnZones: (opts) => http.get('api', '/vn-zones', rd(opts)),
  getVnZone: (zone, opts) => http.get('api', `/vn-zones/${seg(zone)}`, rd(opts)),
};
